type ConstructorAttributeWithoutValue =
  | 'search-container'
  | 'search-input'
  | 'search-submit'
  | 'autocomplete-container'
  | 'search-results-container'
  | 'browse-container'
  | 'product-detail-container'
  | 'recommendations-container'

type ConstructorAttributeWithValue =
  | 'item-id'
  | 'item-name'
  | 'item-variation-id'
  | 'item-price'
  | 'total-number-results'
  | 'button-action'
  | 'filter-name'
  | 'filter-value'
  | 'recommendations-pod-id'
  | 'result-id'

type ConstructorAttributeNames = ConstructorAttributeWithoutValue | ConstructorAttributeWithValue

const CONSTRUCTOR_DATA_ATTRIBUTES: Record<ConstructorAttributeNames, string> = {
  'search-container': 'data-cnstrc-search-form',
  'search-input': 'data-cnstrc-search-input',
  'search-submit': 'data-cnstrc-search-submit-btn',
  'autocomplete-container': 'data-cnstrc-autosuggest',
  'search-results-container': 'data-cnstrc-search',
  'browse-container': 'data-cnstrc-browse',
  'product-detail-container': 'data-cnstrc-product-detail',
  'item-id': 'data-cnstrc-item-id',
  'item-name': 'data-cnstrc-item-name',
  'item-variation-id': 'data-cnstrc-item-variation-id',
  'item-price': 'data-cnstrc-item-price',
  'total-number-results': 'data-cnstrc-num-results',
  'button-action': 'data-cnstrc-btn',
  'filter-name': 'data-cnstrc-filter-name',
  'filter-value': 'data-cnstrc-filter-value',
  'recommendations-container': 'data-cnstrc-recommendations',
  'recommendations-pod-id': 'data-cnstrc-recommendations-pod-id',
  'result-id': 'data-cnstrc-result-id',
}

export type ConstructorAttributeObject = {
  [K in ConstructorAttributeNames]: Record<K, string | boolean | number>
}[ConstructorAttributeNames]

const useSearchProvider = () => {
  const getSearchProviderAttributes = (
    attributesArray: ReadonlyArray<ConstructorAttributeObject>
  ): Record<string, string | true> => {
    return Object.assign(
      {},
      ...attributesArray.map((obj) =>
        Object.entries(obj).reduce((acc, [key, value]) => {
          if (value === true) {
            acc[CONSTRUCTOR_DATA_ATTRIBUTES[key]] = true
          } else if (value !== false && value != null) {
            acc[CONSTRUCTOR_DATA_ATTRIBUTES[key]] = String(value)
          }
          return acc
        }, {} as Record<string, string | true>)
      )
    )
  }

  return { getSearchProviderAttributes }
}

export default useSearchProvider
